module.exports = __webpack_public_path__ + "img/testimonials-2.5a6688e8.jpg";